import React from 'react';

const AnimatedDigit = ({ value, prev }: { value: string; prev: string }) => {
  return (
    <div
      className="relative inline-block h-[1.2em] overflow-hidden min-w-[0.4em]"
      data-testid="animated-digit"
    >
      <div key={value} className="absolute bottom-0 w-full animate-slideDown opacity-100">
        {value}
      </div>
      {prev !== value && (
        <div key={`prev-${prev}`} className="absolute w-full animate-slideUp opacity-0">
          {prev}
        </div>
      )}
    </div>
  );
};

export default AnimatedDigit;
